// extracted by mini-css-extract-plugin
export default {"container":"pag_gVHiU","header":"pag_hea_2My_9","inner":"pag_inn_3T2SG","urbania":"pag_urb_1Fg7G","entered":"pag_ent_3ZMUC","entering":"pag_ent_3py9d","leaving":"pag_lea_1qyrM"};